

































































































































































import { Component, Vue } from 'vue-property-decorator'
import { MenuItemType, UserInfoType } from '../../types/type'
import menuList from '../../utils/menuList'
import { UserModule, CommonModule } from '../../store'
import { findItemForTree } from '../../utils/toolsForCommon'
import bus from '../../utils/eventBus'
@Component({
  name: 'Home',
  components: {
    'breadcrumb-box': () => import('../../components/common/breadcrumb.vue'),
    'footer-container': () => import('../../components/common/myFooter.vue'),
    'header-user': () => import('../../components/common/headerUser.vue')
  }
})
export default class Home extends Vue {
  public closeOrOpenFlag: boolean = false
  public menuList: Array<MenuItemType> = menuList
  public welcomeText: string = ''
  public welcomeTextTimeId: number = 0
  public flagForLogoAndAside: boolean = false
  public flagForOpenCloseAndBreadcrumb: boolean = true

  get onRoutes (): string {
    const { path } = this.$route
    return path || '/'
  }

  get userInfo (): UserInfoType {
    return UserModule.userInfo
  }

  get token (): string {
    return UserModule.token
  }

  get userInfoAuthority (): Array<number> {
    return UserModule.userInfo ? UserModule.userInfo.resultAuthorityList : []
  }

  get allRole () {
    return (this as any).$RoleCode
  }

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get orgName (): string {
    const org = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
    return org && org['name'] ? org['name'] : '- -'
  }

  async mounted () {
    CommonModule.getTreeDataForSubOrganization()
    this.disposeShowOrHideForMenu()
    // 暂时不要跑马灯：
    // this.welcomeTextShow()
    // this.$on('hook:beforeDestroy', () => {
    //   this.welcomeTextTimeId && clearInterval(this.welcomeTextTimeId)
    // })
    // 暂时不要：
    // this.websocketInit()
    // welcome控制：
    bus.$on('operationForShowTheMenu', flag => {
      this.flagForLogoAndAside = flag
    })
    this.$on('hook:beforeDestroy', () => {
      bus.$off('operationForShowTheMenu')
    })
  }

  // 专门处理菜单的显示与隐藏：
  disposeShowOrHideForMenu (): void {
    // 根据权限获取哪些是可以访问的点：&&&&&&&&&&&&&&&&&&&
    const {
      Announcement,
      Organization,
      RoleAuthority,
      UserCorrelation,
      Enumeration,
      Subject,
      CapitalSchool,
      CapitalVillagesAndTowns,
      CapitalCounty,
      CapitalCityInvestment,
      IncomeAndExpenses,
      Voucher,
      ReportForms,
      CanteenInventory,
      CanteenDayToDay,
      SystemSetting,
      WarningConfig,
      WarningQuery,
      SchoolInfoMaintain
    } = this.allRole
    // 新公告（首页相关）：
    const AnnouncementRes = Object.keys(Announcement).filter(item => {
      if (this.userInfoAuthority.includes(Announcement[item].code)) {
        return item
      }
    })
    // 组织架构：
    let OrganizationRes = Object.keys(Organization).filter(item => {
      if (this.userInfoAuthority.includes(Organization[item].code)) {
        return item
      }
    })
    // 角色权限管理：
    let RoleAuthorityRes = Object.keys(RoleAuthority).filter(item => {
      if (this.userInfoAuthority.includes(RoleAuthority[item].code)) {
        return item
      }
    })
    // 用户管理
    let UserCorrelationRes = Object.keys(UserCorrelation).filter(item => {
      if (this.userInfoAuthority.includes(UserCorrelation[item].code)) {
        return item
      }
    })
    // 枚举管理：
    let EnumerationRes = Object.keys(Enumeration).filter(item => {
      if (this.userInfoAuthority.includes(Enumeration[item].code)) {
        return item
      }
    })
    // 科目管理：
    const SubjectRes = Object.keys(Subject).filter(item => {
      if (this.userInfoAuthority.includes(Subject[item].code)) {
        return item
      }
    })
    // 食堂资金管理：
    // 食堂资金管理学校端：
    const CapitalSchoolRes = Object.keys(CapitalSchool).filter(item => {
      if (this.userInfoAuthority.includes(CapitalSchool[item].code)) {
        return item
      }
    })
    // 食堂资金管理中心学校端：
    const CapitalVillagesAndTownsRes = Object.keys(CapitalVillagesAndTowns).filter(item => {
      if (this.userInfoAuthority.includes(CapitalVillagesAndTowns[item].code)) {
        return item
      }
    })
    // 食堂资金管理后勤端：
    const CapitalCountyRes = Object.keys(CapitalCounty).filter(item => {
      if (this.userInfoAuthority.includes(CapitalCounty[item].code)) {
        return item
      }
    })
    // 食堂资金管理城投端：
    const CapitalCityInvestmentRes = Object.keys(CapitalCityInvestment).filter(item => {
      if (this.userInfoAuthority.includes(CapitalCityInvestment[item].code)) {
        return item
      }
    })
    // 食堂财务管理：
    // 流水记录：
    let IncomeAndExpensesRes = Object.keys(IncomeAndExpenses).filter(item => {
      if (this.userInfoAuthority.includes(IncomeAndExpenses[item].code)) {
        return item
      }
    })
    // 凭证：
    let VoucherRes = Object.keys(Voucher).filter(item => {
      if (this.userInfoAuthority.includes(Voucher[item].code)) {
        return item
      }
    })
    // 报表：
    let ReportFormsRes = Object.keys(ReportForms).filter(item => {
      if (this.userInfoAuthority.includes(ReportForms[item].code)) {
        return item
      }
    })
    // 食堂库存管理：
    let CanteenInventoryRes = Object.keys(CanteenInventory).filter(item => {
      if (this.userInfoAuthority.includes(CanteenInventory[item].code)) {
        return item
      }
    })
    // 食堂日常管理：
    let CanteenDayToDayRes = Object.keys(CanteenDayToDay).filter(item => {
      if (this.userInfoAuthority.includes(CanteenDayToDay[item].code)) {
        return item
      }
    })
    // 系统设置：
    let SystemSettingRes = Object.keys(SystemSetting).filter(item => {
      if (this.userInfoAuthority.includes(SystemSetting[item].code)) {
        return item
      }
    })
    // 食堂预警配置：
    let WarningConfigRes = Object.keys(WarningConfig).filter(item => {
      if (this.userInfoAuthority.includes(WarningConfig[item].code)) {
        return item
      }
    })
    // 食堂巡查监管：
    let WarningQueryRes = Object.keys(WarningQuery).filter(item => {
      if (this.userInfoAuthority.includes(WarningQuery[item].code)) {
        return item
      }
    })
    // 学校信息维护：
    let SchoolInfoMaintainRes = Object.keys(SchoolInfoMaintain).filter(item => {
      if (this.userInfoAuthority.includes(SchoolInfoMaintain[item].code)) {
        return item
      }
    })

    // 专门显示隐藏：&&&&&&&&&&&&&&&&&&
    let { menuList } = this
    // 首页配置：
    let CanteenIndexConfigMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '首页配置') as MenuItemType
    if (AnnouncementRes.includes('Announcement_Management_Add_Or_Update')) {
      CanteenIndexConfigMenuListOfOne.show = true
    } else {
      CanteenIndexConfigMenuListOfOne.show = false
    }
    // 首页：
    let CanteenIndexMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '首页') as MenuItemType
    if (AnnouncementRes.includes('Announcement_Management_Query')) {
      CanteenIndexMenuListOfOne.show = true
    } else {
      CanteenIndexMenuListOfOne.show = false
    }
    // 基础管理：
    let BaseMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '基础管理') as MenuItemType
    // 如果组织结构、角色权限管理、用户管理、枚举管理一个模块都没有，那么基础管理不展示
    if (!(OrganizationRes.length + RoleAuthorityRes.length + UserCorrelationRes.length + EnumerationRes.length)) {
      BaseMenuListOfOne.show = false
    } else {
      BaseMenuListOfOne.show = true
    }
    // 组织结构：
    let OrganizationMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '组织架构') as MenuItemType
    if (!OrganizationRes.length) {
      OrganizationMenuListOfOne.show = false
    } else {
      OrganizationMenuListOfOne.show = true
    }
    // 角色权限管理：
    let RoleAuthorityMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '角色管理') as MenuItemType
    if (!RoleAuthorityRes.length) {
      RoleAuthorityMenuListOfOne.show = false
    } else {
      RoleAuthorityMenuListOfOne.show = true
    }
    // 用户管理：
    let UserCorrelationMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '用户管理') as MenuItemType
    if (!UserCorrelationRes.length) {
      UserCorrelationMenuListOfOne.show = false
    } else {
      UserCorrelationMenuListOfOne.show = true
    }
    // 枚举管理：
    let EnumerationMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '枚举管理') as MenuItemType
    if (!EnumerationRes.length) {
      EnumerationMenuListOfOne.show = false
    } else {
      EnumerationMenuListOfOne.show = true
    }
    // 科目管理：
    let CanteenSubjectMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '科目管理') as MenuItemType
    if (!SubjectRes.length) {
      CanteenSubjectMenuListOfOne.show = false
    } else {
      CanteenSubjectMenuListOfOne.show = true
    }
    // 食堂资金管理:
    let CanteenCapitalMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '食堂资金管理') as MenuItemType
    if (!(CapitalSchoolRes.length + CapitalVillagesAndTownsRes.length + CapitalCountyRes.length + CapitalCityInvestmentRes.length)) {
      CanteenCapitalMenuListOfOne.show = false
    } else {
      CanteenCapitalMenuListOfOne.show = true
    }
    // 资金总览：（乡镇端，县级端，城投端的资金总览，学校没有的）
    let CapitalOverviewMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '资金总览') as MenuItemType
    if (CapitalVillagesAndTownsRes.length || CapitalCountyRes.length || CapitalCityInvestmentRes.length) {
      CapitalOverviewMenuListOfOne.show = true
    } else {
      CapitalOverviewMenuListOfOne.show = false
    }
    // 食堂资金管理学校端：
    let CapitalShiftToAffirmMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '资金转出登记（学校）') as MenuItemType
    let CapitalApplicationForUseMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '资金使用申请（学校）') as MenuItemType
    let CapitalApplicationForUseOfPendingMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '待处理资金申请（学校）') as MenuItemType
    let CapitalAppropriationHistoryMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '资金拨付记录（学校）') as MenuItemType
    if (!CapitalSchoolRes.length) {
      CapitalShiftToAffirmMenuListOfOne.show = false
      CapitalApplicationForUseMenuListOfOne.show = false
      CapitalApplicationForUseOfPendingMenuListOfOne.show = false
      CapitalAppropriationHistoryMenuListOfOne.show = false
    } else {
      CapitalShiftToAffirmMenuListOfOne.show = true
      CapitalApplicationForUseMenuListOfOne.show = true
      CapitalApplicationForUseOfPendingMenuListOfOne.show = true
      CapitalAppropriationHistoryMenuListOfOne.show = true
    }
    // 食堂资金管理中心学校端：
    let CapitalApplicationAuditOfVillagesAndTownsMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '资金申请审核（乡镇）') as MenuItemType
    let CapitalApplicationAuditHistoryOfVillagesAndTownsMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '资金审核记录（乡镇）') as MenuItemType
    if (!CapitalVillagesAndTownsRes.length) {
      CapitalApplicationAuditOfVillagesAndTownsMenuListOfOne.show = false
      CapitalApplicationAuditHistoryOfVillagesAndTownsMenuListOfOne.show = false
    } else {
      CapitalApplicationAuditOfVillagesAndTownsMenuListOfOne.show = true
      CapitalApplicationAuditHistoryOfVillagesAndTownsMenuListOfOne.show = true
    }
    // 食堂资金管理后勤端：
    let CapitalApplicationAuditOfCountyMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '资金申请审核（县级）') as MenuItemType
    let CapitalApplicationAuditHistoryOfCountyMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '资金审核记录（县级）') as MenuItemType
    if (!CapitalCountyRes.length) {
      CapitalApplicationAuditOfCountyMenuListOfOne.show = false
      CapitalApplicationAuditHistoryOfCountyMenuListOfOne.show = false
    } else {
      CapitalApplicationAuditOfCountyMenuListOfOne.show = true
      CapitalApplicationAuditHistoryOfCountyMenuListOfOne.show = true
    }
    // 食堂资金管理城投端：
    let CapitalApplicationAuditOfCityInvestmentMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '资金申请审核（城投）') as MenuItemType
    let CapitalApplicationAuditHistoryOfCityInvestmentMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '资金审核记录（城投）') as MenuItemType
    let CapitalApplicationAuditForAppropriationOfCityInvestmentMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '资金拨付审核（城投）') as MenuItemType
    let CapitalApplicationAuditHistoryForAppropriationyOfCityInvestmentMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '资金拨付记录（城投）') as MenuItemType
    let CapitalShiftToAuditOfCityInvestmentMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '资金转入审核（城投）') as MenuItemType
    let CapitalShiftToAuditForAppropriationOfCityInvestmentMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '资金转入审核（城投拨付岗）') as MenuItemType
    let CapitalShiftToHistoryOfCityInvestmentMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '资金转入记录（城投）') as MenuItemType
    let CapitalShiftToHistoryForAppropriationOfCityInvestmentMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '资金转入记录（城投拨付岗）') as MenuItemType
    if (!CapitalCityInvestmentRes.length) {
      CapitalApplicationAuditOfCityInvestmentMenuListOfOne.show = false
      CapitalApplicationAuditHistoryOfCityInvestmentMenuListOfOne.show = false
      CapitalApplicationAuditForAppropriationOfCityInvestmentMenuListOfOne.show = false
      CapitalApplicationAuditHistoryForAppropriationyOfCityInvestmentMenuListOfOne.show = false
      CapitalShiftToAuditOfCityInvestmentMenuListOfOne.show = false
      CapitalShiftToAuditForAppropriationOfCityInvestmentMenuListOfOne.show = false
      CapitalShiftToHistoryOfCityInvestmentMenuListOfOne.show = false
      CapitalShiftToHistoryForAppropriationOfCityInvestmentMenuListOfOne.show = false
    } else {
      CapitalApplicationAuditOfCityInvestmentMenuListOfOne.show = true
      CapitalApplicationAuditHistoryOfCityInvestmentMenuListOfOne.show = true
      CapitalApplicationAuditForAppropriationOfCityInvestmentMenuListOfOne.show = true
      CapitalApplicationAuditHistoryForAppropriationyOfCityInvestmentMenuListOfOne.show = true
      CapitalShiftToAuditOfCityInvestmentMenuListOfOne.show = true
      CapitalShiftToAuditForAppropriationOfCityInvestmentMenuListOfOne.show = true
      CapitalShiftToHistoryOfCityInvestmentMenuListOfOne.show = true
      CapitalShiftToHistoryForAppropriationOfCityInvestmentMenuListOfOne.show = true
      // 申请审核和拨付审核可能不是同一个人，所以又要判断：
      if (!CapitalCityInvestmentRes.includes('CapitalCityInvestment_Management_Audit_Canteen_Apply')) {
        CapitalApplicationAuditOfCityInvestmentMenuListOfOne.show = false
        CapitalApplicationAuditHistoryOfCityInvestmentMenuListOfOne.show = false
        CapitalShiftToAuditOfCityInvestmentMenuListOfOne.show = false
        CapitalShiftToHistoryOfCityInvestmentMenuListOfOne.show = false
      }
      if (!CapitalCityInvestmentRes.includes('CapitalCityInvestment_Management_Confirm_Transfer_Accounts')) {
        CapitalApplicationAuditForAppropriationOfCityInvestmentMenuListOfOne.show = false
        CapitalApplicationAuditHistoryForAppropriationyOfCityInvestmentMenuListOfOne.show = false
        CapitalShiftToAuditForAppropriationOfCityInvestmentMenuListOfOne.show = false
        CapitalShiftToHistoryForAppropriationOfCityInvestmentMenuListOfOne.show = false
      }
    }
    // 食堂财务管理：
    let CanteenFinanceMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '食堂财务管理') as MenuItemType
    // 如果流水记录、凭证、报表一个模块都没有，那么食堂财务管理不展示
    if (!(IncomeAndExpensesRes.length + VoucherRes.length + ReportFormsRes.length)) {
      CanteenFinanceMenuListOfOne.show = false
    } else {
      CanteenFinanceMenuListOfOne.show = true
    }
    // 流水记录：
    let IncomeAndExpensesMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '收支流水记录') as MenuItemType
    if (!IncomeAndExpensesRes.length) {
      IncomeAndExpensesMenuListOfOne.show = false
    } else {
      IncomeAndExpensesMenuListOfOne.show = true
    }
    // 凭证：
    let VoucherMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '凭证管理') as MenuItemType
    if (!VoucherRes.length) {
      VoucherMenuListOfOne.show = false
    } else {
      VoucherMenuListOfOne.show = true
    }
    // 报表：
    let ReportFormsMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '报表管理') as MenuItemType
    if (!ReportFormsRes.length) {
      ReportFormsMenuListOfOne.show = false
    } else {
      ReportFormsMenuListOfOne.show = true
    }
    // 食堂库存管理：
    let CanteenInventoryMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '食堂库存管理') as MenuItemType
    if (!CanteenInventoryRes.length) {
      CanteenInventoryMenuListOfOne.show = false
    } else {
      CanteenInventoryMenuListOfOne.show = true
    }
    // 食堂日常管理：
    let CanteenDayToDayMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '食堂日常管理') as MenuItemType
    if (!CanteenDayToDayRes.length) {
      CanteenDayToDayMenuListOfOne.show = false
    } else {
      CanteenDayToDayMenuListOfOne.show = true
    }
    // 系统设置：
    let SystemSettingMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '系统设置') as MenuItemType
    if (!SystemSettingRes.length) {
      SystemSettingMenuListOfOne.show = false
    } else {
      SystemSettingMenuListOfOne.show = true
    }
    // 食堂预警配置：
    let CanteenEarlyWarningConfigMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '食堂预警配置') as MenuItemType
    if (!WarningConfigRes.length) {
      CanteenEarlyWarningConfigMenuListOfOne.show = false
    } else {
      CanteenEarlyWarningConfigMenuListOfOne.show = true
    }
    // 食堂巡查监管：
    let CanteenPatrolMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '食堂巡查监管') as MenuItemType
    if (!WarningQueryRes.length) {
      CanteenPatrolMenuListOfOne.show = false
    } else {
      CanteenPatrolMenuListOfOne.show = true
    }
    // 学校信息维护：
    let SchoolInfoMaintainMenuListOfOne = findItemForTree(menuList, 'subs', 'title', '学校信息维护') as MenuItemType
    if (!SchoolInfoMaintainRes.length) {
      SchoolInfoMaintainMenuListOfOne.show = false
    } else {
      SchoolInfoMaintainMenuListOfOne.show = true
    }
  }

  // welcomeTextShow (): void {
  //   let _that: any = this
  //   const welcomeText: string = `_欢迎登录${_that.$organizationNameForWelcom}校园智慧食堂_`
  //   const welcomeTextDom = this.$refs.welcomeTextDom
  //   const contentArr = welcomeText.split('')
  //   let content = ''
  //   let index = 0
  //   let timerId = setInterval(() => {
  //     content += contentArr[index]
  //     ;(welcomeTextDom as HTMLElement).innerHTML = `${content}_`
  //     index++
  //     if (index === contentArr.length) {
  //       (welcomeTextDom as HTMLElement).innerHTML = content
  //       clearInterval(timerId)
  //     }
  //   }, 100)
  //   setTimeout(() => {
  //     this.welcomeText = welcomeText
  //     this.welcomeTextRunning(welcomeTextDom)
  //   }, contentArr.length * 100)
  // }

  // welcomeTextRunning (welcomeTextDom): void {
  //   this.welcomeTextTimeId = setInterval(() => {
  //     let str1 = this.welcomeText.substr(0, 1)
  //     let str2 = this.welcomeText.substr(1)
  //     this.welcomeText = str2 + str1
  //     ;(welcomeTextDom as HTMLElement).innerHTML = this.welcomeText
  //   }, 300)
  // }

  // websocket：
  // websocketInit () {
  //   const _that: any = this
  //   const websocket = new WebSocket(`${_that.$websocketURL}/educationWS?token${this.token}`)
  //   websocket.onopen = function (evt: any) {
  //     console.log('websocket onopen', evt)
  //     websocket.send('test')
  //   }
  //   websocket.onclose = function (evt: any) {
  //     console.log('websocket onclose', evt)
  //   }
  //   websocket.onmessage = async function (evt: any) {
  //     console.log('websocket onmessage', evt)
  //     // WebSocket协议支持三种本地消息类型
  //     // 1、文本消息   2、二进制消息   3、Ping消息 和 Pong消息
  //     // Ping 和 Pong消息的作用：
  //     // 1）两种消息通常被用来检查WebSocket连接的健康性，（连接是否有效）。
  //     // 2）可以通过测量Ping和Pong消息所花费的时间来测算WebSocket连接的效率。
  //     // console.log(evt.data instanceof ArrayBuffer)
  //     // console.log(evt.data instanceof Blob)
  //     // console.log(typeof evt.data === "string")
  //     _that.$notify.info({
  //       title: 'title',
  //       message: `<strong>message</strong>`,
  //       duration: 0,
  //       dangerouslyUseHTMLString: true
  //     })
  //   }
  //   websocket.onerror = function (evt: any) {
  //     console.log('websocket onerror', evt)
  //   }
  // }
}
